module.exports = __webpack_public_path__ + "static/media/alejandro-gomez.c82c9483.png";